// File: AnnualComplianceForSociety.jsx
import React from "react";

export default function AnnualComplianceForSociety() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Annual Compliance for Society
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks handles annual filings and records for registered societies.
          </p>
          <p className="text-gray-700">
            Complete society compliance including Annual General Meeting (AGM) coordination, financial audit management, Registrar of Societies filings, governing body updates, and statutory record maintenance under Societies Registration Act.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Society compliance Registrar filings India) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Society annual compliance Registrar filings"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless society compliance filings.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Financial statements and audit reports</li>
                <li>Updated member list and governing body</li>
                <li>Annual returns and activity reports</li>
                <li>AGM minutes and resolutions</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Accurate statutory compliance support for registered societies across India.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Complete AGM Management
                </h3>
                <p className="text-gray-700 text-sm">
                  Annual General Meeting coordination including 21-day notice circulation, agenda preparation, quorum management, financial statements approval, auditor appointment, governing body elections, and resolution recording as per Societies Registration Act requirements.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Registrar Filings Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Timely submission of annual returns to Registrar of Societies, governing body change notifications, audited financial statements, activity reports, membership updates, and compliance certificates ensuring active registration status and penalty avoidance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Statutory Record Maintenance
                </h3>
                <p className="text-gray-700 text-sm">
                  Full record-keeping services including member register updates, minutes book maintenance, cash book/ledger management, receipt/asset registers, statutory audit coordination, FCRA compliance (if applicable), and state-specific renewal filings for perpetual compliance.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
